import { render, staticRenderFns } from "./Closures.vue?vue&type=template&id=2b1a70e2&scoped=true&"
import script from "./Closures.vue?vue&type=script&lang=js&"
export * from "./Closures.vue?vue&type=script&lang=js&"
import style0 from "./Closures.vue?vue&type=style&index=0&id=2b1a70e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a70e2",
  null
  
)

export default component.exports